/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useMemo } from 'react';
import { withRouter } from 'react-router';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment/moment';
import {
  setErrorMessages,
  setGridData,
  getAllIneligibleCPT,
  updateIneligibleCpt,
  resetIneligibleCPTStore,
  setDeletedData,
  validateIneligibleProvider,
} from '../Store/Actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import IneligibleProvHeader from './gridComponents/tableHead';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  closeTab,
  handleScrollToEvent,
  validDate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  navigateToNextCell,
  onCellFocused,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import DeleteBoxRender from './gridComponents/deleteBoxFramework';
import BeginEndDateFramework from './gridComponents/BeginEndDateFramework';
import {
  compareTwoDatesGreaterThanOrEqual,
  formatToCorrectDate,
  getDateInMMDDYYYYFormat,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  checkActionAccessByRole,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import TextBoxRender from './gridComponents/TextBoxRender';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

const MaintainIneligibleCPTComponent = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessages = useSelector((state) => {
    return state.sharedState.IneligibleCPTReducer?.errorMessagesInRedux;
  });
  const resultData = useSelector((state) => {
    return state.sharedState.IneligibleCPTReducer.ineligibleCPTListData;
  });
  const userId = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data?.userId
  );
  const gridData = useSelector((state) => {
    return state.sharedState.IneligibleCPTReducer?.gridData;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  /** false when user has State Employee role (REACT_APP_STATE_ONLY_ROLE) — edit actions blocked */
  const isEditDisabledByRole = !isEnablebyRole;

  const gridRef = React.useRef();
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [localStorageValue, setLocalStorageValue] = useState(null);
  const [openErrIngPrv, setOpenErrIngPrv] = useState(false);
  const [gridParams, setGridParams] = React.useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [selectRow, setSelectRow] = React.useState({});
  const [childSelected, setChildSelected] = useState(null);

  // handing by default first row selection function
  const onGridReady = (params) => {
    if (params) {
      setGridParams(params);
      params.api.forEachNode((node) => node?.setSelected(false));
    }
  };
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    if (kcRoles?.userPrivileges?.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, [kcRoles]);
  const handleGridData = (value) => {
    dispatch(setGridData(value));
  };
  const searchAllIneligibleCPT = async (value, timeOut) =>{
    await Promise.resolve();
    // setTimeout(() => {
      dispatch(setGridData([]));
      dispatch(getAllIneligibleCPT({}));
    // }, timeOut);
  }

  useEffect(() => {
    setShowViewHistory(false);
    if (gridData?.length < 1) {
      const values = {};
      searchAllIneligibleCPT(values, 0);
    }
  }, []);
  useEffect(() => {
    if (
      resultData &&
      resultData.message === 'SUCESS' &&
      !gridData?.length > 0
    ) {
      const gridDataResultValue =
        resultData?.data?.length > 0 && resultData.data;
      dispatch(setGridData([]));
      if (gridDataResultValue) {
        gridDataResultValue.map((x) => {
          const beginDt = x.ineligProviderBeginDt
            ? x.ineligProviderBeginDt?.split('/')
            : [];
          const ineligEndDt = x.ineligEndDt ? x.ineligEndDt?.split('/') : [];
          x.ineligProviderBeginDt =
            beginDt.length === 3 && beginDt[2].startsWith('00')
              ? formatToCorrectDate(x.ineligProviderBeginDt)
              : x.ineligProviderBeginDt;
          x.ineligEndDt =
            ineligEndDt.length === 3 && ineligEndDt[2].startsWith('00')
              ? formatToCorrectDate(x.ineligEndDt)
              : x.ineligEndDt;
        });
      }
      handleGridData(gridDataResultValue);
    } else if (resultData?.error === 'API failed') {
      searchAllIneligibleCPT({}, 0);
      dispatch(
        setErrorMessages([
          {
            field: 'APIFailed',
            errorType: 'APIFailed',
            message: constantMessageData.FAILED_MESSAGE_GENERIC,
          },
        ])
      );

      setSuccessMessages([]);
    }
  }, [resultData]);

  // handing highlight tab
  React.useEffect(() => {
    if (errorMessages?.length > 0) {
      tabHighLigther('/maintainIneligibleCPT', true);
    } else {
      tabHighLigther('/maintainIneligibleCPT', false);
    }
  }, [JSON.stringify(errorMessages)]);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      gridData?.filter((x) => {
        return x.addEditRow;
      })?.length > 0
    ) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/maintainIneligibleCPT') {
            item.isFormDirty = true;
          } else if (item.navTo === '/maintainIneligibleCPT')
            item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [gridData]);
  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs?.filter((x) => {
        return x.navTo === '/maintainIneligibleCPT' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs?.map((item) => {
        if (item.navTo === '/maintainIneligibleCPT' && item.isFormSave) {
          item.isFormSave = false;
          if (isFormValid()) {
            masterDataSave(true);
          }
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const isFormValid = () => {
    let localErr = [];
    let rowIndexId = 0;
    if (gridParams?.columnApi && gridParams?.columnApi !== null) {
      gridParams.columnApi.applyColumnState({
        state: [{ colId: 'procedureCd', sort: '' }],
      });
    }
    const newObj =
      gridData?.filter((x) => {
        return x.newRecord;
      })?.length > 0
        ? [
            ...gridData?.map((item) => {
              item.ineligBeginDtErr = false;
              item.endDtErr = false;
              item.procedureCdErr = false;
              return item;
            }),
          ]
        : [
            ...gridData?.map((item) => {
              item.ineligBeginDtErr = false;
              item.endDtErr = false;
              item.procedureCdErr = false;
              return item;
            }),
          ];
    if (gridData.length > 0) {
      gridData.forEach((item, rowIndex) => {
        if (!item.deleteRecord) {
          rowIndexId = gridData.findIndex((x) => {
            return x.tempId === item.tempId;
          });
          if (item?.procedureCd === '' || item?.procedureCd === null) {
            newObj[rowIndexId].procedureCdErr = true;
            localErr.push({
              fieldName: `procedureCd${rowIndex}`,
              errorType: 'CPTcodeRequired',
              message: `${constantMessageData.CPT_CODE_REQUIRED} ${
                rowIndex + 1
              }.`,
            });
            dispatch(setGridData(newObj));
          }
          if (
            (item?.ineligBeginDt || item?.ineligEndDt) &&
            (validDate(new Date(item?.ineligBeginDt)) === false ||
              validDate(new Date(item?.ineligEndDt)) === false)
          ) {
            if (
              item?.ineligBeginDt &&
              validDate(new Date(item?.ineligBeginDt)) === false
            ) {
              newObj[rowIndexId].ineligBeginDtErr = true;
              localErr.push({
                fieldName: `ineligBeginDt${rowIndex}`,
                errorType: 'InvalidDate',
                message: `${
                  constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE
                } ${rowIndex + 1}.`,
              });
              dispatch(setGridData(newObj));
            } else if (
              item?.ineligEndDt &&
              validDate(new Date(item?.ineligEndDt)) === false
            ) {
              newObj[rowIndexId].endDtErr = true;
              localErr.push({
                fieldName: `ineligEndDt${rowIndex}`,
                errorType: 'InvalidDate',
                message: `${
                  constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE
                } ${rowIndex + 1}.`,
              });
              dispatch(setGridData(newObj));
            } else {
              newObj[rowIndexId].endDtErr = true;
              newObj[rowIndexId].ineligBeginDtErr = true;
              localErr = localErr?.filter(
                (item) =>
                  item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
              );
            }
          } else if (item.ineligBeginDt !== undefined) {
            if (item.ineligBeginDt === '' || item.ineligBeginDt === null) {
              newObj[rowIndexId].ineligBeginDtErr = true;
              dispatch(setGridData(newObj));
              localErr = localErr?.filter(
                (item) =>
                  item.fieldName !== `ineligBeginDt${rowIndex}` &&
                  item.errorType !==
                    ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
              );
              localErr.push({
                fieldName: `ineligBeginDt${rowIndex}`,
                errorType: 'dateRequired',
                message: `${
                  constantMessageData.INEDIBILITY_PERIOD_BEGIN_DATE_REQ
                } ${rowIndex + 1}.`,
              });
            } else if (
              item?.ineligEndDt !== null &&
              item?.ineligEndDt !== '' &&
              item?.ineligEndDt !== 'Invalid date' &&
              compareTwoDatesGreaterThanOrEqual(
                new Date(item?.ineligEndDt),
                moment(new Date(item?.ineligBeginDt))
              )
            ) {
              newObj[rowIndexId].endDtErr = true;
              localErr = localErr?.filter(
                (item) =>
                  item.fieldName !== `ineligEndDt${rowIndex}` &&
                  item.errorType !==
                    ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
              );

              localErr.push({
                fieldName: `ineligEndDt${rowIndex}`,
                errorType: 'compareDateGreater',
                tabName: 'CoverageGap',
                message: `${
                  constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
                } ${rowIndex + 1}.`,
              });
            }
          } else if (
            item?.ineligEndDt !== null &&
            item?.ineligEndDt !== '' &&
            validDate(new Date(item?.ineligEndDt)) === false
          ) {
            newObj[rowIndexId].endDtErr = true;
            localErr = localErr?.filter(
              (item) =>
                item.fieldName !== `ineligEndDt${rowIndex}` &&
                item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
            );
            localErr.push({
              fieldName: `ineligEndDt${rowIndex}`,
              errorType: 'compareDateGreater',

              message: `${
                constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
              } ${rowIndex + 1}.`,
            });
            dispatch(setGridData(newObj));
          } else if (
            item?.ineligEndDt !== null &&
            item?.ineligEndDt !== '' &&
            compareTwoDatesGreaterThanOrEqual(
              new Date(item?.ineligEndDt),
              moment(newObj[rowIndexId].ineligBeginDt)
            )
          ) {
            newObj[rowIndexId].endDtErr = true;
            localErr = localErr?.filter(
              (item) =>
                item.fieldName !== `ineligEndDt${rowIndex}` &&
                item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
            );
            localErr.push({
              fieldName: `ineligEndDt${rowIndex}`,
              errorType: 'compareDateGreater',
              tabName: 'CoverageGap',
              message: `${
                constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
              } ${rowIndex + 1}.`,
            });
            dispatch(setGridData(newObj));
          } else {
            newObj[rowIndexId].endDtErr = false;
            newObj[rowIndexId].ineligBeginDtErr = false;

            localErr = localErr?.filter(
              (item) =>
                item.fieldName !== `ineligEndDt${rowIndex}` &&
                item.fieldName !== `ineligBeginDt${rowIndex}` &&
                item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
            );
            dispatch(setGridData(newObj));
          }
        } else {
          return item;
        }
      });
    }
    dispatch(setErrorMessages([...new Set(localErr)]));
    return !localErr?.length > 0;
  };

  const clearMessages = () => {
    setSuccessMessages([]);
  };
  const masterDataSave = async (willClose = false) => {
    clearMessages();
    setOpen(false);
    let tempObj = [];
    if (
      gridData?.filter((x) => {
        return x.addEditRow;
      })?.length > 0
    ) {
      if (isFormValid()) {
        tempObj = {
          delIneligibleCPTList: gridData
            ?.filter((x) => {
              return x.deleteRecord;
            })
            ?.map((item) => {
              return {
                ineligBeginDt: item?.ineligBeginDt
                  ? moment(item?.ineligBeginDt).format('MM/DD/YYYY')
                  : null,
                ineligEndDt: item?.ineligEndDt
                  ? moment(item?.ineligEndDt).format('MM/DD/YYYY')
                  : null,
                procedureCd: item?.procedureCd,
                lastUserId: userId?.toUpperCase(),
              };
            }),
          saveIneligibleCPTList: gridData
            ?.filter((x) => {
              return x.addEditRow && !x.deleteRecord;
            })
            ?.map((item) => {
              return {
                ineligBeginDt: item?.ineligBeginDt
                  ? moment(item?.ineligBeginDt).format('MM/DD/YYYY')
                  : null,
                ineligEndDt: item?.ineligEndDt
                  ? moment(item?.ineligEndDt).format('MM/DD/YYYY')
                  : null,
                procedureCd: item?.procedureCd,
                lastUserId: userId?.toUpperCase(),
              };
            }),
        };
      }

      if (
        tempObj?.saveIneligibleCPTList?.length > 0 ||
        tempObj?.delIneligibleCPTList?.length > 0
      ) {
        const updateRes = await dispatch(updateIneligibleCpt(tempObj));
        if (updateRes?.status === '001') {
          setSuccessMessages([constantMessageData.SUCCESSMESSAGE_GENERIC]);

          searchAllIneligibleCPT({}, 3000);
          dispatch(setGridData([]));
          const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
          const newObj1 = updateTabs?.map((item) => {
            if (item.navTo === '/maintainIneligibleCPT') {
              item.isFormSave = false;
              item.isFormDirty = false;
              item.isFormError = false;
            }
            return item;
          });
          localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
          if (gridParams?.columnApi && gridParams?.columnApi !== null) {
            gridParams.columnApi.applyColumnState({
              state: [{ colId: 'procedureCd', sort: 'asc' }],
            });
            gridParams.api.refreshCells();
          }
          if (willClose) {
            dispatch(resetIneligibleCPTStore());
            await Promise.resolve();
            // setTimeout(() => {
              closeTab('/maintainIneligibleCPT', history);
            // });
          } 
        } else {
          searchAllIneligibleCPT({}, 0);
          dispatch(
            setErrorMessages([
              {
                field: 'APIFailed',
                errorType: 'APIFailed',
                message: constantMessageData.FAILED_MESSAGE_GENERIC,
              },
            ])
          );
          setSuccessMessages([]);
        }
      }
    }
    setOpen(false);
  };

  // set save alert open
  const openSave = () => {
    if (isEditDisabledByRole) return;
    setSuccessMessages([]);
    if (isFormValid()) {
      setOpen(true);
    }
  };

  // set save alert close
  const handleSaveClose = () => {
    setOpen(false);
  };
  // set Cancel alert open
  const openCancelPopup = () => {
    setSuccessMessages([]);
    setOpenCancel(true);
  };
  // set Cancel Alert close and reset all data
  const handleCancel = () => {
    clearMessages();
    dispatch(setErrorMessages([]));
    searchAllIneligibleCPT({}, 0);
    setOpenCancel(false);
    if (gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };

  const addNewIneligibleCPT = () => {
    if (isEditDisabledByRole) return;
    setIsOpen(true);
    clearMessages();
    const newObj = [...gridData];
    newObj.unshift({
      tempId: uuidv4,
      addEditRow: true,
      newRecord: true,
      procedureCd: null,
      ineligBeginDt: '',
      ineligEndDt: '',
      ineligProviderBeginDtErr: false,
      procedureCdErr: false,
      isFromAPI: false,
      endDtErr: false,
      deleteRecord: false,
    });
    handleGridData(newObj);
  };
  // click on delete button after call
  const deleteSelectRowData = (activeRow) => {
    setIsOpen(true);
    clearMessages();
    const newObj = [...gridData];
    const temp = newObj?.map((item) => {
      if (item.tempId === activeRow?.tempId) {
        item.ineligProviderBeginDtErr = false;
        item.endDtErr = false;
        item.procedureCdErr = false;
        item.deleteRecord = true;
        item.addEditRow = true;
      }
      return item;
    });
    handleGridData(temp);
  };
  const handleDeleteRow = async () => {
    setIsOpen(false);
    setSuccessMessages([]);
    dispatch(setErrorMessages([]));
    const payload = [];
    payload.push({
      procedureCd: childSelected.data?.procedureCd,
      ineligBeginDt: childSelected.data?.ineligBeginDt,
      ineligEndDt: childSelected.data?.ineligEndDt,
      ineligProviderBeginDtErr: false,
      procedureCdErr: false,
      endDtErr: false,
      lastUpdateDt: childSelected.data.lastUpdateDt,
      newRecord: false,
      updateRecord: false,
      deleteRecord: true,
      addEditRow: true,
    });
    if (childSelected?.data?.isFromAPI) {
      const deleteReq = {
        startDate: childSelected.data.ineligBeginDt
          ? moment(childSelected.data.ineligBeginDt).format('MM/DD/YYYY')
          : null,
        endDate: childSelected.data.ineligEndDt
          ? moment(childSelected.data.ineligEndDt).format('MM/DD/YYYY')
          : null,
      };

      const deleteRes = await validateIneligibleProvider(deleteReq);

      if (deleteRes === constantMessageData.ING_BE_ERR) {
        setOpenErrIngPrv(true);
      } else {
        const newDataAdd = gridData?.map((item) => {
          if (item.tempId === childSelected?.data?.tempId) {
            item.newRecord = false;
            item.updateRecord = false;
            item.deleteRecord = true;
            item.addEditRow = true;
          }
          return item;
        });
        dispatch(setGridData(newDataAdd));
      }
    } else {
      const newDataAdd = [...gridData];
      const newDataFilter = newDataAdd?.filter(
        (x) => x.tempId !== childSelected.data.tempId
      );

      dispatch(setGridData(newDataFilter));
    }

    setOpenDelete(false);
    setChildSelected(null);
    clearMessages();
  };

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
    clearMessages();
  };
  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0];
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        CPT_CODE: `${selectedRow?.procedureCd}`,
        INELEG_CPT_BEGIN_DT: `${selectedRow?.ineligBeginDt}`,
      });
    }
  };

  const frameworkComponents = useMemo(() => {
    return {
      ProcedureCdCellRenderer: (params) => {
        return (
          <TextBoxRender {...params} fieldsDisabled={isEditDisabledByRole} />
        );
      },
      StartDate: (params) => {
        return (
          <BeginEndDateFramework
            {...params}
            fieldsDisabled={isEditDisabledByRole}
          />
        );
      },
      ineligEndDtCellRenderer: (params) => {
        return (
          <BeginEndDateFramework
            {...params}
            fieldsDisabled={isEditDisabledByRole}
          />
        );
      },
      deleteBoxRenderer: (props) => (
        <DeleteBoxRender
          {...props}
          readOnly={isEditDisabledByRole}
          onClick={(row) => {
            if (isEditDisabledByRole) return;
            dispatch(setDeletedData(row));
            setSelectRow(row?.data);
            setChildSelected(row);
            setOpenDelete(true);
            clearMessages();
          }}
        />
      ),
    };
  }, [isEditDisabledByRole]);
  const gridHeight = fullScreenView ? '70vh' : 350;

  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        <Spinner load={spinnerLoader} />
        <div>
          <SaveCancelPopup
            open={openDelete}
            title="Delete Ineligible CPT"
            moduleName="the selected record"
            onConfim={() => {
              setOpenDelete(false);
              handleDeleteRow(selectRow);
            }}
            onCancel={() => setOpenDelete(false)}
            content={
              childSelected?.data?.isFromAPI
                ? constantMessageData.ING_CONFIRM
                : `${constantMessageData.INELIGIBLE_CPT_CODE_DELETE_CONF_MSG} ${
                    (childSelected?.node?.rowIndex || 0) + 1
                  } ?`
            }
          />
          <SaveCancelPopup
            open={openErrIngPrv}
            title="Maintain Ineligible CPT"
            isInfo
            onConfim={() => {
              setOpenErrIngPrv(false);
            }}
            onCancel={() => {
              setOpenErrIngPrv(false);
            }}
            content={constantMessageData.INELIGIBLE_CPT_CODE_FROZEN_INV_MSG}
          />

          <SaveCancelPopup
            open={open}
            title="Save"
            onConfim={() => {
              masterDataSave();
            }}
            onCancel={() => {
              setOpen(false);
            }}
          />
          <SaveCancelPopup
            open={openCancel}
            title="Cancel"
            onConfim={() => {
              handleCancel();
            }}
            onCancel={() => {
              setOpenCancel(false);
            }}
          />
        </div>
        <div>
          <CustomSeparator parent1="Maintain" parent2="Ineligible CPT" />
        </div>
        <div>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessages?.length > 0
                  ? _.map(errorMessages, (l) => l.message)
                  : []
              ),
            ]}
          />
          {!errorMessages?.length > 0 && (
            <DisplaySuccessMessages successMessages={successMessages} />
          )}
          {!fullScreenView && (
            <div className="flex-block justify-end pb-1">
              <div className="btn-wrapper float-right">
                <Button
                  className="btn btn-success btn-save"
                  onClick={openSave}
                  disabled={
                    isEditDisabledByRole ||
                    gridData?.filter((x) => {
                      return x.addEditRow || x.deleteRecord;
                    })?.length < 1
                  }
                >
                  {' '}
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => openCancelPopup()}
                  disabled={
                    isEditDisabledByRole ||
                    gridData?.filter((x) => {
                      return x.addEditRow || x.deleteRecord;
                    })?.length < 1
                  }
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="panel tBillPanel-space pb-0 frr-tbl-with-feature">
        <div className="clearfix" />
        <TableGridWithFeatures
          ref={gridRef}
          rowData={
            gridData?.length > 0
              ? gridData?.filter((x) => {
                  return !x.deleteRecord;
                })
              : []
          }
          columnDefs={IneligibleProvHeader(localStorageValue)}
          gridHeight={gridHeight}
          gridCall={onGridReady}
          frameworkComponents={frameworkComponents}
          fileName="Ineligible CPT Code"
          addTxt="Add New Ineligible CPT"
          addAction={addNewIneligibleCPT}
          disableAddAction={isEditDisabledByRole}
          enterMovesDown
          suppressCellFocus
          exportFile
          noGlobalSort
          onCellFocused={onCellFocused}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          fullScreenView={fullScreenView}
          handleViewHistory={handleViewHistory}
          handleFullScreenViewClick={handleFullScreenViewClick}
        />
        {showViewHistory && (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="INELIG_CPT"
            keyValue={keyValue}
          />
        )}
      </div>
    </div>
  );
};
export default withRouter(MaintainIneligibleCPTComponent);
